import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('Uncaught error in component tree:', error, info);
    this.setState({ error, info });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{padding:24}}>
          <h2>Something went wrong.</h2>
          <p>The application encountered an unexpected error. See console for details.</p>
          {this.state.error && (
            <details style={{whiteSpace:'pre-wrap',marginTop:12}}>
              {this.state.error.toString()}
              {this.state.info?.componentStack}
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
